import MuiStepButton, { StepButtonProps } from '@mui/material/StepButton';
import EDTooltip from '../../Tooltip/EDTooltip';

interface IProps extends StepButtonProps {
  disabledReason?: string;
}

const EDStepButton = (props: IProps) => {
  let { title, disabledReason, ...rest } = props;

  if (rest.disabled && disabledReason && disabledReason !== '') {
    return (
      <EDTooltip title={disabledReason} enableClickOnTouch>
        <span>
          <MuiStepButton {...rest} />
        </span>
      </EDTooltip>
    );
  }

  return title && title !== '' ? (
    <EDTooltip title={title}>
      <MuiStepButton {...rest} />
    </EDTooltip>
  ) : (
    <MuiStepButton {...rest} />
  );
};

export default EDStepButton;
